import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["usageTracker", "featureGroup", "featureName", "featureNameForDescription", "screen"];
import { HubUserAttributesClient } from 'frontend-preferences-client';
import { useEffect, useState } from 'react';
import { useGetUniversalUsagePeriodUsage } from '../../../../hooks/useGetUniversalUsagePeriodUsage';
import { useUserCanEditBilling } from '../../../../hooks/useUserCanEditBilling';
import { COMPONENT_NAMES } from '../../../../shared/constants';
import { ComponentViewTracker } from '../../../../utils/UsageTracking/ComponentViewTracker';
import { FeatureUsageStatusBanner } from './FeatureUsageStatusBanner';
import { jsx as _jsx } from "react/jsx-runtime";
export function CreditStatusBanner(_ref) {
  var _data$billingActionDe;
  let {
      usageTracker,
      featureGroup,
      featureName,
      featureNameForDescription,
      screen
    } = _ref,
    alertProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const [userPreferencesData, setUserPreferencesData] = useState({});
  const {
    data
  } = useGetUniversalUsagePeriodUsage({
    showBreakdown: false
  });
  const billingType = data === null || data === void 0 || (_data$billingActionDe = data.billingActionDetails) === null || _data$billingActionDe === void 0 ? void 0 : _data$billingActionDe.type;
  const hubUserAttributesClient = HubUserAttributesClient.forCaller('hs-usage-based-billing-fe');
  const {
    'UBB:LastCreditStatusBannerSeen': lastBannerSeen,
    'UBB:LastCreditStatusBannerLimitSeen': lastBannerLimitSeen
  } = userPreferencesData;
  const isAdmin = useUserCanEditBilling();
  useEffect(() => {
    const fetchUserPreferencesData = async () => {
      const attributes = await hubUserAttributesClient.batchFetch({
        'UBB:LastCreditStatusBannerSeen': '',
        'UBB:LastCreditStatusBannerLimitSeen': ''
      });
      setUserPreferencesData(attributes);
    };
    void fetchUserPreferencesData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  if (!data || billingType !== 'DISABLED') {
    return null;
  }
  if (!usageTracker) {
    console.warn('Usage-based billing:Usage tracker is not available');
    return null;
  }
  return /*#__PURE__*/_jsx(ComponentViewTracker, {
    usageTracker: usageTracker,
    componentName: COMPONENT_NAMES.CREDIT_STATUS_BANNER.MAIN,
    screen: screen,
    children: /*#__PURE__*/_jsx(FeatureUsageStatusBanner, Object.assign({
      lastBannerSeen: lastBannerSeen,
      lastBannerLimitSeen: parseInt(lastBannerLimitSeen, 10),
      featureGroup: featureGroup,
      featureName: featureName,
      featureNameForDescription: featureNameForDescription,
      creditsUsed: data.creditsUsed,
      totalCredits: data.totalCredits,
      resetDate: data.userReadableEndDate,
      usageTracker: usageTracker,
      isAdmin: isAdmin,
      billingType: billingType
    }, alertProps))
  });
}